export default function ClearSession(){
    {
    localStorage.clear();
    window.location.reload(false);
    }
}